var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseSingleVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    clipPath: "url(#clip0_16465_20817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8022 6.49098C18.4122 6.10098 17.7822 6.10098 17.3922 6.49098L12.5022 11.371L7.61217 6.48098C7.22217 6.09098 6.59217 6.09098 6.20217 6.48098C5.81217 6.87098 5.81217 7.50098 6.20217 7.89098L11.0922 12.781L6.20217 17.671C5.81217 18.061 5.81217 18.691 6.20217 19.081C6.59217 19.471 7.22217 19.471 7.61217 19.081L12.5022 14.191L17.3922 19.081C17.7822 19.471 18.4122 19.471 18.8022 19.081C19.1922 18.691 19.1922 18.061 18.8022 17.671L13.9122 12.781L18.8022 7.89098C19.1822 7.51098 19.1822 6.87098 18.8022 6.49098Z",
    fill: "#172B4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16465_20817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.501953 0.78125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSingleVector);
export default __webpack_public_path__ + "static/media/closeSingleVector.f3c7709c90ad4d966cb6838888d8b63b.svg";
export { ForwardRef as ReactComponent };